import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation SendEmailToCustomer(
    $orderId: ID!
    $from: String!
    $subject: String!
    $message: String
  ) {
    sendEmailToCustomer(
      input: {
        orderId: $orderId
        from: $from
        subject: $subject
        message: $message
      }
    ) {
      id
    }
  }
`;

export default MUTATION;
